import React from 'react';

import { cn } from '@/utils/cn';

type BadgeVariant = 'warning' | 'danger' | 'success';

type BadgeProps = {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
};

const variants: Record<BadgeVariant, string> = {
  warning: 'bg-yellow-100 text-yellow-800',
  danger: 'bg-red-100 text-red-600',
  success: 'bg-[#E7FDDF] text-[#279643]',
};

const CustomBadge = ({ children, className, variant }: BadgeProps) => {
  return (
    <span className={cn('inline-block text-base font-medium px-[15px] rounded-[99px] py-1', className, variants[variant])}>{children}</span>
  );
};

export default CustomBadge;
